var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16373 10.2727C5.95091 8.42822 8.0082 4.88115 11.5553 5.02303C11.2715 3.74609 10.4202 2.61103 9.28515 2.0435C8.52122 1.62654 7.67879 1.37335 6.81157 1.30007C5.94435 1.22678 5.07138 1.33501 4.24831 1.61785C3.18419 1.97256 2.26196 2.75291 1.62349 3.67515C1.05595 4.59739 0.914072 5.66151 1.1269 6.65468C1.41066 7.78975 2.12007 8.71198 3.11325 9.35045C2.97137 9.84704 2.75855 10.3436 2.61666 10.9112C3.18419 10.6274 3.82267 10.2727 4.3902 9.98893C4.95773 10.1308 5.52526 10.2727 6.16373 10.2727Z",
    stroke: "#2B2828",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7337 9.13734C16.308 8.28605 15.6695 7.64757 14.8892 7.22193C13.3994 6.51251 11.6968 6.51251 10.278 7.22193C9.28482 7.71851 8.50446 8.64075 8.2207 9.77581C8.00787 10.6271 8.2207 11.4784 8.64635 12.1878C9.35576 13.2519 10.4199 13.9614 11.6968 14.1742C12.5481 14.3161 13.4704 14.2451 14.3217 14.0323C14.8182 14.2451 15.3148 14.5289 15.8114 14.8126L15.3858 13.5357C15.9533 13.181 16.4499 12.6135 16.7337 12.0459C17.0884 11.0528 17.0884 10.0596 16.7337 9.13734Z",
    stroke: "#2B2828",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.e4b193d1.svg";
export { ForwardRef as ReactComponent };